import { render, staticRenderFns } from "./AddEditCollegeAdmin.vue?vue&type=template&id=dab1fab2&scoped=true&"
import script from "./AddEditCollegeAdmin.vue?vue&type=script&lang=js&"
export * from "./AddEditCollegeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AddEditCollegeAdmin.vue?vue&type=style&index=0&id=dab1fab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab1fab2",
  null
  
)

export default component.exports